module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_20.9a3bd977.pdf";